import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["readView", "editView"];

  connect() {
    [this.readViewTarget, this.editViewTarget].forEach((el) => {
      Object.assign(el.style, {
        transition: "opacity 0.25s ease, max-height 0.3s ease",
        overflow: "hidden",
      });
    });
    this.#collapse(this.editViewTarget, false);
  }

  edit(event) {
    event.preventDefault();
    this.#collapse(this.readViewTarget, true);
    // Small delay so the outgoing fade finishes before the incoming starts
    setTimeout(() => this.#expand(this.editViewTarget), 150);
  }

  cancel(event) {
    event.preventDefault();
    this.#collapse(this.editViewTarget, true);
    setTimeout(() => {
      this.#resetFields();
      this.#expand(this.readViewTarget);
    }, 150);
  }

  // --- private helpers ---

  #expand(el) {
    el.hidden = false;
    // Force layout so the transition triggers from 0
    el.offsetHeight; // eslint-disable-line no-unused-expressions
    el.style.opacity = "1";
    el.style.maxHeight = el.scrollHeight + "px";
    // After transition, remove max-height so content can reflow naturally
    const cleanup = () => {
      el.style.maxHeight = "none";
      el.removeEventListener("transitionend", cleanup);
    };
    el.addEventListener("transitionend", cleanup);
  }

  #collapse(el, animate) {
    if (animate) {
      // Pin current height so max-height transition can animate down
      el.style.maxHeight = el.scrollHeight + "px";
      el.offsetHeight; // eslint-disable-line no-unused-expressions
    }
    el.style.opacity = "0";
    el.style.maxHeight = "0";
    if (animate) {
      const hide = () => {
        el.hidden = true;
        el.removeEventListener("transitionend", hide);
      };
      el.addEventListener("transitionend", hide);
    } else {
      el.hidden = true;
    }
  }

  #resetFields() {
    this.editViewTarget.querySelectorAll("input, select, textarea").forEach((field) => {
      if (field.type === "radio" || field.type === "checkbox") {
        field.checked = field.defaultChecked;
      } else {
        field.value = field.defaultValue;
      }
    });

    // Re-fire change on radios that gate visibility for other controllers (e.g. allergy-toggle).
    this.editViewTarget
      .querySelectorAll('input[name="allergies_toggle"]:checked')
      .forEach((radio) => radio.dispatchEvent(new Event("change", { bubbles: true })));
  }
}
